// Add logout functionality
import React, { useState, useEffect } from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import { logout, getUserRole } from '../../services/auth';
import { toast } from 'react-toastify';
import { useActivePath } from './useActivePath';



const Navigation = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [user, setUser] = useState(null);
    const [userRole, setUserRole] = useState(null);
    const navigate = useNavigate();
    const { isExactActive } = useActivePath();


    useEffect(() => {
        const userData = localStorage.getItem('user');
        const role = getUserRole();
        if (userData) {
            setUser(JSON.parse(userData));
            setUserRole(role);
        }
    }, []);

    const handleLogout = async () => {
        await logout();
        toast.success('Logged out successfully');
        navigate('/login');
    };



    return (
        <header className="top-nav-horizontal">
            <div className="navbar-container">
                <Link to="/admin/dashboard" className="navbar-brand-custom">
                    <img src={`${process.env.PUBLIC_URL}/admin_logo.png`} />
                </Link>

                <button
                    className="mobile-toggle-menu"
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                >
                    <i className="fas fa-bars"></i>
                </button>

                <ul className={`nav-menu-horizontal ${mobileMenuOpen ? 'show' : ''}`}>
                    {/* Dashboard - Everyone */}
                    <li className="nav-item-h">
                        <NavLink to="/admin/dashboard" className={({ isActive }) => `nav-link-h ${isActive ? 'active' : ''}`}>
                            <i className="fas fa-tachometer-alt"></i> <span>Dashboard</span>
                        </NavLink>
                    </li>

                    <li className="nav-item-h">
                        <NavLink to="/admin/banners" className={({ isActive }) => `nav-link-h ${isActive ? 'active' : ''}`}>
                            <i className="fas fa-tachometer-alt"></i> <span>Banners</span>
                        </NavLink>
                    </li>

                    <li className="nav-item-h dropdown">
                        <a href="#" className="nav-link-h dropdown-toggle" data-bs-toggle="dropdown">
                            <i className="fas fa-history"></i> <span>News Management</span> <i className="fas fa-chevron-down dropdown-arrow"></i>
                        </a>
                        <ul className="dropdown-menu dropdown-menu-custom">

                            <li><NavLink to="/admin/news" className="dropdown-item"><i className="fas fa-list-alt"></i>Create News</NavLink></li>
                            <li><NavLink to="/admin/news-list" className="dropdown-item"><i className="fas fa-list-alt"></i>News List</NavLink></li>

                        </ul>
                    </li>


                    <li className="nav-item-h dropdown">
                        <a href="#" className="nav-link-h dropdown-toggle" data-bs-toggle="dropdown">
                            <i className="fas fa-history"></i> <span>Ads Management</span> <i className="fas fa-chevron-down dropdown-arrow"></i>
                        </a>
                        <ul className="dropdown-menu dropdown-menu-custom">

                            <li><NavLink to="/admin/ads" className="dropdown-item"><i className="fas fa-list-alt"></i>Create Ads</NavLink></li>
                            <li><NavLink to="/admin/ads-list" className="dropdown-item"><i className="fas fa-list-alt"></i>Ads List</NavLink></li>

                        </ul>
                    </li>


                    <li className="nav-item-h dropdown">
                        <a href="#" className="nav-link-h dropdown-toggle" data-bs-toggle="dropdown">
                            <i className="fas fa-video"></i> <span>Videos Management</span> <i className="fas fa-chevron-down dropdown-arrow"></i>
                        </a>
                        <ul className="dropdown-menu dropdown-menu-custom">
                            <li><NavLink to="/admin/videos" className="dropdown-item"><i className="fas fa-plus-circle"></i>Add Video</NavLink></li>
                            <li><NavLink to="/admin/videos-list" className="dropdown-item"><i className="fas fa-list-alt"></i>Video List</NavLink></li>
                        </ul>
                    </li>




                </ul>

                <div className="user-area">


                    <div className="dropdown">
                        <button className="user-dropdown-btn" data-bs-toggle="dropdown">
                            <div className="user-avatar">
                                <i className="fas fa-user-circle"></i>
                            </div>
                            <span className="user-name">{user?.name || 'Staff'}</span>

                            <i className="fas fa-chevron-down fa-xs"></i>
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end">
                            <li><NavLink to="/user/profile" className="dropdown-item small"><i className="fas fa-user me-2"></i>Profile</NavLink></li>
                            <li><NavLink to="/user/change-password" className="dropdown-item small"><i className="fas fa-key me-2"></i>Change Password</NavLink></li>
                            <li><hr className="dropdown-divider" /></li>
                            <li><button className="dropdown-item small text-danger" onClick={handleLogout}><i className="fas fa-sign-out-alt me-2"></i>Logout</button></li>
                        </ul>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Navigation;